export default {
    getDriverPlanner: (state) => {
        return state.driverPlanner
    }
}
